//驼峰命名法转串行命名法，如 fontSize 转为 font-size
export function convertCamelToKebab(camelStr) {
    // 判断是否是 大驼峰
    const isUpper = camelStr[0].charCodeAt(0) >= 65 && camelStr[0].charCodeAt(0) <= 90;
    const handleStr = camelStr.replace(/([A-Z])/g, '-$1').toLowerCase();
    let kebabStr = handleStr;
    if (isUpper) {
        kebabStr = handleStr.slice(1);
    }
    // 处理连续大写的情况
    const newKebabArr = [];
    const kebabSplitArr = kebabStr.split('-');
    kebabSplitArr.forEach((item, index) => {
        if (item.length > 1) {
            newKebabArr.push(item);
        } else {
            let combineStr = '';
            const subKebabArr = kebabSplitArr.slice(index);
            for (let i = 0; i < subKebabArr.length; i++) {
                if (subKebabArr[i].length > 1) break;
                combineStr += subKebabArr[i];
            }
            newKebabArr.push(combineStr);
            kebabSplitArr.splice(index + 1, combineStr.length - 1);
        }
    })
    return newKebabArr.join('-');
}

export function sleep(millis) {
    return new Promise(resolve=>setTimeout(resolve, millis));
}

export function countWordsAndCharacters(text) {
    // 正则表达式匹配英文单词
    const englishWords = text.match(/[a-zA-Z]+/g) || [];
    // 正则表达式匹配中文字符
    const chineseCharacters = text.match(/[\u4e00-\u9fa5]/g) || [];

    // 英文单词数量
    const englishWordCount = englishWords.length;
    // 中文字符数量
    const chineseCharacterCount = chineseCharacters.length;

    // 总数
    const totalCount = englishWordCount + chineseCharacterCount;

    return {
        englishWordCount,
        chineseCharacterCount,
        totalCount
    };
}
